import Constants from "../utils/constants";
import { API } from "../apis/APIsConfig";
import { CalcularFondoModel } from "../models/calcularfondos";

export function getAportes(salario) {
  return API.get(Constants.APIURLS.CALCULATORS.APORTES + salario);
}

export function getAportesDetalle(salario) {
  return API.get(Constants.APIURLS.CALCULATORS.APORTESDETALLE + salario);
}

export function postCalcularFondo(model: CalcularFondoModel) {
  return API.post(Constants.APIURLS.CALCULATORS.CALCULARFONDO, model);
}
